import styled from 'styled-components';

import { Badge } from 'ui/badge';
import { GRAPHQL_TYPENAMES } from 'modules/graphql/types';
import { WorkflowStatusBadge } from 'modules/workflowIndex/components/WorkflowsTable/WorkflowStatusBadge';
import { BADGE_VARIANTS_FOR_CAMPAIGN_STATUSES } from 'modules/campaignIndex/constants';

import { Cell } from './table';
import { PlaceholderText } from './PlaceholderText';
import { TABLE_COLUMNS } from './constants';
import { ListReference } from '../../domain';

type ListReferenceStatusCellProps = {
  listReference: ListReference;
  rowIndex: number;
};

const StyledBadge = styled(Badge)`
  width: fit-content;
`;

export const ListReferenceStatusCell = ({
  listReference: dependent,
  rowIndex,
}: ListReferenceStatusCellProps) => {
  if (dependent.__typename === GRAPHQL_TYPENAMES.CAMPAIGN) {
    return (
      <Cell data-test="list-usage-status-cell" columnId={TABLE_COLUMNS.STATUS} rowIndex={rowIndex}>
        <StyledBadge variant={BADGE_VARIANTS_FOR_CAMPAIGN_STATUSES[dependent.campaignState]}>
          {dependent.campaignState}
        </StyledBadge>
      </Cell>
    );
  }

  if (dependent.__typename === GRAPHQL_TYPENAMES.JOURNEY) {
    return (
      <Cell data-test="list-usage-status-cell" columnId={TABLE_COLUMNS.STATUS} rowIndex={rowIndex}>
        <WorkflowStatusBadge workflow={dependent} />
      </Cell>
    );
  }

  return (
    <Cell data-test="list-usage-status-cell" columnId={TABLE_COLUMNS.STATUS} rowIndex={rowIndex}>
      <PlaceholderText>N/A</PlaceholderText>
    </Cell>
  );
};
